import React, { useEffect } from 'react'
import { FormProvider, useFieldArray, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { Button, Icon } from '../../../../../../components/UI'
import MyQuizTemplateCreateTask from './MyQuizTemplateCreateTask'
import ErrorMessageWithExclamation from '../../../../../../components/UI/ErrorMessageWithExclamation'

import { QuizTemplateCreateTaskScheme } from '../../../../../../routing/utils/validators'

import createEmptyQuestion from '../../../../../../helpers/createEmptyQuestion'
import transformQuestionsData from '../../../../../../helpers/transformQuestionsData'

const MyQuizTemplateCreateTasks = ({ quiz, setStep, setQuizTemplateData, quizTemplateData }) => {
  const methods = useForm({
    defaultValues: {
      questions:
        quiz && quizTemplateData?.questions
          ? transformQuestionsData(quizTemplateData.questions)
          : quizTemplateData?.questions || [createEmptyQuestion()],
    },
    resolver: yupResolver(QuizTemplateCreateTaskScheme),
  })

  const {
    formState: { errors },
    setValue,
    handleSubmit,
    control,
  } = methods

  const {
    fields: questions,
    append,
    remove,
  } = useFieldArray({
    control,
    name: 'questions',
  })

  const handleAddQuestion = () => {
    append(createEmptyQuestion())
  }

  const handleFormSubmit = (data) => {
    setStep(3)
    setQuizTemplateData({
      ...quizTemplateData,
      ...data,
    })
  }

  const handleBack = () => {
    setStep(1)
  }

  useEffect(() => {
    if (quiz && quizTemplateData?.questions) {
      setValue('questions', transformQuestionsData(quizTemplateData.questions))
    }
  }, [quiz, quizTemplateData])

  const questionsContent = questions.map((question, index) => {
    return <MyQuizTemplateCreateTask key={question.id} index={index} onDelete={remove} />
  })

  return (
    <FormProvider {...methods}>
      <form className="w-full flex flex-col" onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="gap-y-[24px] w-[calc(100%+296px)] mx-[-148px] px-[148px] flex flex-col max-h-[600px] overflow-y-auto primary-scroll">
          {questionsContent}
        </div>

        {typeof errors.questions?.message === 'string' && (
          <ErrorMessageWithExclamation text={errors.questions.message} className="!mt-[16px]" />
        )}

        <Button
          type="button"
          className="mx-auto flex items-center justify-center w-fit font-semibold mt-[24px]"
          onClick={handleAddQuestion}
        >
          <Icon name="plus" color="#ffffff" className="mr-[8px] w-[24px] h-[24px]" />

          <span className="text-sm font-semibold text-white">Add New Questions</span>
        </Button>

        <Button type="submit" className="w-full font-semibold mt-[24px]">
          Continue
        </Button>

        <button
          type="button"
          className="text-base font-semibold text-[#F79009] mx-auto mt-[16px]"
          onClick={handleBack}
        >
          Back
        </button>
      </form>
    </FormProvider>
  )
}

export default MyQuizTemplateCreateTasks
